import { cn } from "../lib/utils";
import { Badge } from "./badge";
import { Typography } from "./typography";

type SelectionCounterProps = {
  selected: number;
  total: number;
  className?: string;
};

const SelectionCounter: React.FC<SelectionCounterProps> = ({
  selected,
  total,
  className,
}) => {
  return (
    <Badge variant="filled" className={cn("w-fit p-1", className)}>
      <Typography
        variant="caption"
        trans="selected_counter"
        transParams={{ selected, total }}
      />
    </Badge>
  );
};

export default SelectionCounter;
